import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import RequestsView from "../views/RequestsView.vue";
import TrialsView from "../views/TrialsView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/map-requests",
    name: "requests",
    component: RequestsView,
  },
  {
    path: "/trials",
    name: "trials",
    component: TrialsView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
